import { Search } from 'js-search'
export default function() {
  return {
    mappings: [],
    /**
     *
     * @param {QuickSearchMapping} mapping
     * @returns
     */
    addCriteria(mapping) {
      this.mappings.push(mapping)
      return this
    },
    /**
     *
     * @returns {QuickSearchMapping[]}
     */
    build() {
      return this.mappings
    }
  }
}

export class QuickSearchMapping {
  constructor(
    items = [],
    linkBuilder = item => item,
    searchFor = 'title',
    title = 'title',
    uids = ['slug']
  ) {
    this.linkBuilder = linkBuilder
    this.searchFor = searchFor
    this.title = title
    const mappedItems = [...items]
    mappedItems.forEach(o => {
      if (o) {
        o.buildedUrl = linkBuilder(o)
        o.buildedTitle = o[title]
      }
    })
    this.search = new Search(uids)
    this.search.addIndex(searchFor)
    this.search.addDocuments(mappedItems)
  }
}
